import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { RentalService } from '../../services/rental.service';
import { Rental } from '../../models/rental.model';

@Component({
  selector: 'app-admin-rentals',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './admin-rentals.component.html',
  styleUrl: './admin-rentals.component.scss',
})
export class AdminRentalsComponent {
rentals: Rental[] = [];

  constructor(private rentalService: RentalService, private router: Router) {}

  ngOnInit() {
    // Firestore fetch
    this.rentalService.getRentals().subscribe(r => {
      this.rentals = r;
    });
  }

  addRental() {
    this.router.navigate(['/admin/add']);
  }

  editRental(id: string) {
    this.router.navigate(['/admin/edit', id]);
  }

  async deleteRental(id: string) {
    if (confirm('Are you sure you want to delete this rental?')) {
      await this.rentalService.deleteRental(id);
      // Optionally show a success message
    }
  }
}
